import i18n from 'i18next';

/** Получить текущую локаль для Intl */
export const getNumberLocale = (): string => {
  return i18n.language?.startsWith('ru') ? 'ru-RU' : 'en-US';
};

/** Получить десятичный разделитель для текущей локали */
export const getDecimalSeparator = (): string => {
  return i18n.language?.startsWith('ru') ? ',' : '.';
};

/** Нормализовать строку числа для отправки на сервер (запятая -> точка) */
export const normalizeNumberForServer = (value: string): string => {
  return value.replace(',', '.');
};

/** Получить разделитель аргументов функций для текущей локали */
export const getArgSeparator = (): string => {
  return i18n.language?.startsWith('ru') ? ';' : ',';
};

/** Получить регулярное выражение для валидации ввода числа */
export const getDecimalRegex = (): RegExp => {
  const sep = getDecimalSeparator();
  const escapedSep = sep === '.' ? '\\.' : sep;
  return new RegExp(`^-?\\d*${escapedSep}?\\d{0,3}$`);
};
